var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cz2__rotate-screen"},[_c('div',{staticClass:"cz2__rotate-screen-content"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('ROTATE_PHONE'))+" ")]),_c('img',{attrs:{"src":require("../assets/icons/rotate.svg"),"aria-hidden":"true","width":"64","height":"30"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }